import React from "react";
import { Bot, X } from "lucide-react";
import styles from "./ChatHeader.module.css";

const ChatHeader = ({ onClose }) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.headerIcon}>
          <Bot className={styles.headerIconSvg} />
        </div>
        <div className={styles.headerText}>
          <h2 className={styles.headerTitle}>Чат с ИИ</h2>
          <p className={styles.headerSubtitle}>
            Помощник по выбору и уходу за вещами
          </p>
        </div>
      </div>
      <button
        onClick={onClose}
        className={styles.closeButton}
        type="button"
        title="Закрыть"
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default ChatHeader;
